export const fallbackLng = 'en'
export const languages = [fallbackLng, 'es', 'it', 'fr', 'zh', 'pt', 'ja']
export const defaultNS = 'common'
export const cookieName = 'i18next'

// Language display names for UI
export const languageNames: Record<string, string> = {
  en: 'English',
  es: 'Español',
  it: 'Italiano',
  fr: 'Français',
  zh: '简体中文',
  pt: 'Português',
  ja: '日本語'
}

// Language flags for visual UI
export const languageFlags: Record<string, string> = {
  en: '🇺🇸',
  es: '🇪🇸',
  it: '🇮🇹',
  fr: '🇫🇷',
  zh: '🇨🇳',
  pt: '🇵🇹',
  ja: '🇯🇵'
}

export function getOptions (lng = fallbackLng, ns = defaultNS) {
    return {
      // debug: true,
      supportedLngs: languages,
      fallbackLng,
      lng,
      fallbackNS: defaultNS,
      defaultNS,
      ns
    }
  }